export default __webpack_public_path__ + "static/media/up-coming-event-3.89184cab.png";